import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-user-assign-stock-program',
  templateUrl: './user-assign-stock-program.component.html',
  styleUrls: ['./user-assign-stock-program.component.css'],

})
export class UserAssignStockProgramComponent implements OnInit {


  programOrderGuid: string | undefined

  loading: boolean = false;

  constructor(
      private _router: Router,
      private _messageService: MessageService,
      public translateService: TranslateService,
      private _activatedRoute: ActivatedRoute,
      public translate: TranslateService,
  ){
      this._activatedRoute.params.subscribe(params => {
      this.programOrderGuid = params['programOrderGuid']
    })
  }

  ngOnInit(): void {

  }

}
